import type React from 'react';

import { useConsultation } from '@entities/consultations';

import { Avatar } from '@mui/material';

import * as st from './styles.module.scss';

type Props = {
	id: number;
};

export const ConsultationBuyer: React.FC<Props> = ({ id }) => {
	const { consultation } = useConsultation(id);

	const getName = () => {
		if (!consultation || !consultation.user) return;
		const { user } = consultation;
		return `${user.last_name} ${user.first_name} ${user.middle_name ?? ''}`;
	};

	return (
		<div className={st.buyer}>
			<Avatar sx={{ width: 40, height: 40 }} src={consultation?.user.photo}>
				{consultation?.user.last_name?.slice(0, 1)}
			</Avatar>
			<div className={st.buyer__name}>{getName()}</div>
		</div>
	);
};
